import React from 'react';
import {  Row, Col } from 'react-bootstrap';

import Button from 'src/components/button';
import styles from './Styles.module.scss';
import { toast } from 'react-toastify';
import { localizedStrings } from 'src/localization';
import Toast from 'src/components/toast';
import Text from 'src/components/text';
class DeleteNDASignatureView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedSliders = this.localizatedSettings.templates.nda.sliders;
  }

  _handleDeleteClick() {
    this.props.deleteNDATemplate(this.props.item.id).then(() => {
      if (this.props.onDeletion) {
        this.props.onDeletion();
      } 
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <Col sm={8} className={styles.column}>
            <div className={styles.heading}>{this.localizedSliders.title}</div>
            <div className={styles.label}>1 {this.localizedSliders.sub_text}</div>

            <p className={styles.description}>
              {this.localizedSliders.description}
                </p>
          </Col>
          <Col sm={12} className={styles.column}>
          {this.props.item &&
          <div className={styles.ndaName}>
            <Text text={this.props.item.name} lines={1} tooltip={{placement:"bottom"}} />
          </div>
          }
          </Col>
        </Row>
        <div className={styles.buttonTray}>
            <Button
              text={this.props.deleting ? `${this.localizedCommonActions.deleting}...` : this.localizedCommonActions.delete}
              variant='primary'
              icon='paperflite-delete'
              disabled={this.props.deleting}
              onClick={() => { this._handleDeleteClick() }}
              />
              <Button
              text={this.localizedCommonActions.cancel}
              onClick={() => { this._handleCancelClick() }}
              disabled={this.props.deleting}
              />
        </div>
      </div>
    );
  }
}
export default DeleteNDASignatureView;